import { Component } from '@angular/core';

@Component({
  selector: 'app-lane-occupancy-portal',
  templateUrl: './lane-occupancy-portal.component.html',
  standalone: false,
})
export class LaneOccupancyPortalComponent {}
